<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

const props = defineProps({
  appUrl: { type: String, required: true },
});

const route = useRoute();
const store = useStore();
const currentUser = computed(() => store.getters['getCurrentUser']);

const iframeSrc = computed(() => {
  const url = new URL(props.appUrl);
  url.searchParams.set('account_id', route.params.accountId);
  url.searchParams.set('user_token', currentUser.value?.access_token || '');
  url.searchParams.set('embedded', '1');
  // --- NUEVO: reenviar query params al iframe (action, conversation_id, contact_name) ---
  const query = route.query;
  Object.keys(query).forEach(key => {
    if (!url.searchParams.has(key)) url.searchParams.set(key, query[key]);
  });
  // --- FIN NUEVO ---
  return url.toString();
});
</script>
<template>
  <div class="flex flex-col w-full h-full">
    <iframe
      :src="iframeSrc"
      class="w-full h-full border-0"
      title="Flowin App"
      allow="clipboard-write"
    />
  </div>
</template>
